import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { io } from 'socket.io-client'

import { helpdeskNotificationsApi } from '../api/services/helpdeskNotificationsApi'

const useHelpdeskSocket = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user.user)

  useEffect(() => {
    const socketUrl = process.env.REACT_APP_SOCKET_URL
    if (!socketUrl || !user?.id) return undefined

    const socket = io(socketUrl, { query: { users_id: user.id } })

    socket.on('helpdesk_notification', (data) => {
      if (data?.title) {
        toast.info(data.title, { position: 'top-center' })
      }

      dispatch(
        helpdeskNotificationsApi.util.updateQueryData('getUnreadHelpdeskNotifications', undefined, (draft) => {
          if (!draft.some((notification) => notification.notification_id === data.notification_id)) {
            draft.unshift(data)
          }
        }),
      )
      dispatch(helpdeskNotificationsApi.util.invalidateTags(['HelpdeskNotifications']))
    })

    return () => {
      socket.off('helpdesk_notification')
      socket.disconnect()
    }
  }, [user?.id, dispatch])
}

export default useHelpdeskSocket
